import { useTrans } from '@/shared/hooks/useTranslation';
import { cn } from '@/shared/utils/cn';
import type { ModeToggleViewState } from '@/viewmodel/features/workspace';
import { LayoutDashboard, LayoutGrid, Sparkles } from 'lucide-react';
import type { ReactNode } from 'react';

const TAB_CLASS =
  'flex items-center gap-1.5 sm:gap-2 px-2.5 sm:px-4 py-1.5 rounded-full text-xs sm:text-sm font-medium transition-colors';

function tabClass(selected: boolean): string {
  return cn(
    TAB_CLASS,
    selected ? 'bg-surface text-primary shadow-sm' : 'text-muted-foreground hover:text-foreground',
  );
}

export function HeaderModeToggle({
  isAgentRoute,
  backToDashboards,
  selectAgent,
  selectDataStudio,
}: Readonly<ModeToggleViewState>): ReactNode {
  const { t } = useTrans();

  return (
    <div
      role="tablist"
      aria-label={t('header.modeToggle.aria')}
      className="flex items-center gap-1 p-1 rounded-full bg-background border border-border justify-self-center [&_button]:cursor-pointer"
    >
      <button
        type="button"
        role="tab"
        aria-selected={isAgentRoute}
        onClick={selectAgent}
        className={tabClass(isAgentRoute)}
      >
        <Sparkles size={14} />
        <span className="hidden sm:inline">{t('header.modeToggle.agent')}</span>
      </button>
      <button
        type="button"
        role="tab"
        aria-selected={!isAgentRoute}
        onClick={selectDataStudio}
        className={tabClass(!isAgentRoute)}
      >
        {backToDashboards ? <LayoutDashboard size={14} /> : <LayoutGrid size={14} />}
        <span className="hidden sm:inline">
          {backToDashboards ? t('header.modeToggle.dashboards') : t('header.modeToggle.dataStudio')}
        </span>
      </button>
    </div>
  );
}
